import { useTranslation } from "react-i18next";
import {
  useCreateRealWorldConnection,
  useGetRealWorldConnection,
  getRealWorldConnection,
} from "@packages/api/madlenAPI";
import { RealWorldConnectionResponseDto } from "@packages/api/madlenAPI.schemas";
import GenericToolCreationPage from "../../../components/tool_components/GenericToolCreationPage";
import { CreateModalProps } from "../../../components/create-modal";
import {
  Connection,
  ConnectionCard,
} from "../../../components/connections/ConnectionCard";
import RealWorldConnectionCreateModal from "@features/tools/components/create-modal/RealWorldConnectionCreateModal";

const CreateConnectionView = () => {
  const { t } = useTranslation();

  const CreateModalWrapper = ({
    initialInput,
    onSubmit,
    isLoading,
    error,
  }: Partial<CreateModalProps>) => (
    <RealWorldConnectionCreateModal
      title={t("connections.result.loading.title")}
      backPath="/content/connections"
      themeColor="orange"
      loadingTitle={t("connections.result.loading.title")}
      errorTitle={t("connections.result.error.title")}
      errorDescription={t("connections.result.error.description")}
      submitButtonText={t("common.generate")}
      initialInput={initialInput!}
      onSubmit={onSubmit!}
      isLoading={isLoading!}
      error={error!}
    />
  );

  const ToolCardWrapper = ({
    toolData,
    isImageLoading,
    onCreateAgain,
  }: {
    toolData: RealWorldConnectionResponseDto;
    isImageLoading: boolean;
    onCreateAgain: () => void;
  }) => (
    <ConnectionCard
      id={toolData.id}
      courseName={toolData.courseName!}
      prompt={toolData.title || toolData.prompt!}
      gradeLevel={toolData.gradeLevel!}
      connections={toolData.connections as unknown as Connection[]}
      imageUrl={toolData.imageUrl!}
      videoUrl={toolData.videoUrl}
      isImageLoading={isImageLoading}
      createdAt={toolData.createdAt}
      usageContext={toolData.usageContext}
      implementationGuide={toolData.implementationGuide}
      skillFocus={toolData.skillFocus}
      author={toolData.authorName!}
      contentLanguage={toolData.contentLanguage!}
      onCreateAgain={onCreateAgain}
    />
  );

  return (
    <GenericToolCreationPage
      toolType="connections"
      useCreateTool={useCreateRealWorldConnection}
      useGetTool={useGetRealWorldConnection}
      getTool={getRealWorldConnection}
      ToolCard={ToolCardWrapper}
      CreateModalWrapper={CreateModalWrapper}
      toolDataExtractor={(data: RealWorldConnectionResponseDto) =>
        data?.connections && data?.connections.length > 0
      }
    />
  );
};

export default CreateConnectionView;
